import React from "react";
import { useHistory } from "react-router-dom";
import { Modal, Row, Col, Button } from "antd";
import styles from "../DashBoard/DashBoard.module.scss";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import { useTripActions } from "../../hooks/useTripActions";
import { TrackAnalytics } from "../../types/ApplicationTypes";

type Props = {
  trip: ITripDetails;
  isCancelModalVisible: boolean;
  setIsCancelModalVisible: Function;
};

const CancelTripModal: React.FC<Props> = ({
  trip,
  isCancelModalVisible,
  setIsCancelModalVisible,
}) => {
  const history = useHistory();
  const { cancelTrip } = useTripActions();

  const handleYesCancel = () => {
    cancelTrip(trip);
    TrackAnalytics("/DashBoard", "Trip is cancelled", "Dashboard Mobile Page");
    history.goBack();
  };

  const handleClose = () => setIsCancelModalVisible(false);

  return (
    <Modal
      visible={isCancelModalVisible}
      centered
      className={styles.modalContainer}
      footer={
        <Row justify="center" gutter={[10, 10]} className={styles.modalBtns}>
          <Col>
            <Button className={styles.modalCloseBtn} onClick={handleClose}>
              Close
            </Button>
          </Col>
          <Col>
            <Button className={styles.modalYesBtn} onClick={handleYesCancel}>
              Yes, Cancel
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col className={styles.modalHeading}>Cancel Service</Col>
      </Row>
      <Row justify="center" className={styles.modalContent}>
        <Col>
          Are you sure you want to cancel this service? This cannot be undone.
        </Col>
      </Row>
    </Modal>
  );
};

export default CancelTripModal;
